import React, { useEffect } from 'react';
import {
  WizardContext,
  Step,
  useWizard,
  UseWizardOptions,
  useCurrentStepIndex,
  WizardInterpreter,
} from '@kizi/comparator-core';
import { Form } from './Form';

export type WizardProps = {
  steps: Step[];
  layout: React.ReactNode[];
  wizardCallback?: (wizard: WizardInterpreter) => void;
  onRender?: () => void;
} & UseWizardOptions;

export const Wizard = ({
  steps,
  layout,
  wizardCallback,
  onRender,
  ...wizardOptions
}: WizardProps) => {
  const wizardService = useWizard(steps, wizardOptions);
  const currentIndex = useCurrentStepIndex(wizardService);
  useEffect(() => {
    if (wizardCallback) wizardCallback(wizardService);
  }, [wizardService]);

  const Forms = (steps ?? []).map((step, i) => {
    /* instantiate a Form for each step */
    const formLayout: React.ReactNode = i < layout.length ? layout[i] : [];
    return (
      <div key={step.name ?? '' + i}>
        {currentIndex === i && (
          <Form name={step.name} fields={[]} formIndex={i} onRender={onRender}>
            {formLayout}
          </Form>
        )}
      </div>
    );
  });

  return (
    <WizardContext.Provider value={{ wizardService }}>
      {Forms}
    </WizardContext.Provider>
  );
};
